import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { createMobileCss2 } from '~/css/createMobileCss';
import { flex, jc } from '~/modules/AppLayout/FlexGridCss';
export const FubonHeader1 = styled.div `
  width: 100%;
  height: 45px;
  background: linear-gradient(to right, #018ad1, #01b6ad);
`;
export const FubonLogo = styled.img `
  position: absolute;
  max-width: 200px;
  left: 16%;
  transform: translateX(-84%);
  ${createMobileCss2(css `
    width: 0;
  `)}
`;
export const FubonHeader2 = styled.div `
  position: relative;
  height: 140px;
  width: 100%;
  ${flex.h.allCenter};
  ${jc.spaceAround}

  margin: auto;
`;
export const FubonHeader3 = styled.div `
  width: 100%;
  height: 8px;
  background: linear-gradient(to right, #018ad1, #01b6ad);
`;
export const RankingDivider = styled.div `
  display: inline-block;
  height: 2px;
  background: ${props => props.color};
  vertical-align: middle;
  position: relative;
  top: -1px;
  width: 35%;
  ${createMobileCss2(css `
    width: 25%;
  `)}
`;
